// extracted by mini-css-extract-plugin
module.exports = {"shadow":"StaticDataGeneral_shadow__3VEXo","gridWrapper":"StaticDataGeneral_gridWrapper__3oAVN","separator":"StaticDataGeneral_separator__3tgdN"};